
<div class="modal">
  <!-- TRUCK BANNER -->
  <div class="truck-banner">
    <div class="truck-left">
      <div class="truck-thumb">
        <svg width="20" height="14" viewBox="0 0 24 17" fill="none">
          <rect x="0" y="2" width="15" height="11" rx="1.5" fill="#9ca3af"/>
          <path d="M15 5.5h5l3 4v4h-8V5.5z" fill="#9ca3af"/>
          <circle cx="4.5" cy="15" r="2" fill="#fff" stroke="#9ca3af" stroke-width="1.2"/>
          <circle cx="19" cy="15" r="2" fill="#fff" stroke="#9ca3af" stroke-width="1.2"/>
        </svg>
      </div>
      <div>
        <div class="truck-id">{{truckDetails?.truckNumber}}</div>
        <div class="truck-model">{{truckDetails?.truckModel}} · {{truckDetails?.truckSize}}</div>
      </div>
    </div>
    <div class="truck-right">
      <span class="km-pill">Current KM: <strong>{{truckDetails?.initialKmTravelled}}</strong></span>
      <span class="live-pill" *ngIf="statusCount"><span class="green-dot" ></span> {{statusCount.Live ? statusCount.Live : '0'}} Live Components</span>
    </div>
  </div>

  <!-- BODY -->
  <div class="modal-body">
    <div class="step-heading">STEP 1 - SELECT COMPONENT TO REMOVE</div>
    <input
      type="text"
      placeholder="Search by type, serial, association..."
      [(ngModel)]="searchText"
      (input)="filterData()"
      class="form-control mb-2 searchText"
    />
  <div class="remove-table">
    <table class="comp-table">
      <thead>
        <tr>
          <th class="th-check"></th>
          <th>TYPE</th>
          <th>Association Type</th>
          <th>SERIAL NO.</th>
          <th>ASSOCIATED FROM</th>
          <th>TOTAL KM TRAVEL</th>
          <!-- <th>KM RUN SO FAR</th> -->
        </tr>
      </thead>

      <tbody>

        <tr *ngFor="let item of filteredTransactions "
            [class.row-selected]="isSelected(item)">
          <td >
            <input
              type="checkbox"
              [checked]="isSelected(item)"
              (change)="toggleSelection(item)">
          </td>

          <td>
            <span class="type-badge"
                  [ngClass]="getBadgeClass(item.componentType)">
              <span class="type-dot"></span>
              {{item.componentType}}
            </span>
          </td>
          <td class="td-serial">{{item.associationType}}</td>
          <td class="td-serial">{{item.serialNumber}}</td>
          <td>{{item.purchaseDate| CustomDatePipe : 'D-M-YYYY'}}</td>
          <td>{{item.totalKmTravelled}} km</td>
          <!-- <td>
            <span class="km-run" [class.initialKmTravelled]="item.initialKmTravelled === 0">
              {{item.initialKmTravelled}} km ↑
            </span>
          </td> -->
        </tr>
      </tbody>
    </table>
  </div>
    <div class="table-note">Only live components are shown. Select one to remove.</div>

    <!-- STEP 2 -->
    <div class="step-heading" style="margin-top:18px;">STEP 2 - DISASSOCIATION DETAILS</div>
    <div class="form-row">
      <div class="form-col">
        <label class="form-label"><span class="req">*</span>To Date (Removal Date)</label>
        <div class="input-wrap">
          <p-calendar appendTo="body" class="mfgDate" name="date" [(ngModel)]="deAssociationDate" view="date" dateFormat="dd.mm.yy"  [maxDate]="maxDate"></p-calendar>
          <!-- <input class="form-input" id="toDate" type="date" placeholder="DD / MM / YYYY" oninput="updateSummary()"/> -->
          <span class="suffix-icon">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                 stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2"/>
              <line x1="16" y1="2" x2="16" y2="6"/>
              <line x1="8"  y1="2" x2="8"  y2="6"/>
              <line x1="3"  y1="10" x2="21" y2="10"/>
            </svg>
          </span>
        </div>
        <div class="form-hint">Date component is physically removed</div>
      </div>
      <div class="form-col">
        <label class="form-label"><span class="req">*</span>Km At Removal</label>
        <div class="input-wrap">
          <input class="form-input" id="kmAtRemoval" type="text" [(ngModel)]="deAssociationkm" placeholder="e.g. 2032" oninput="updateSummary()"/>
          <span class="suffix-text">km</span>
        </div>
        <div class="form-hint">Odometer reading at time of removal</div>
      </div>

      <div class="form-col">
        <label><span class="req">*</span> Association Status</label>
        <div class="select-wrap">
            <ng-select appendTo="body" [(ngModel)]="deAssociationStatus"  placeholder="Select " class="field-input filled">
              <ng-option *ngFor="let item of statusList" [value]="item.value">{{item?.label}}</ng-option>
            </ng-select>
        </div>
      </div>
    </div>

    <!-- CONFIRM BOX -->
    <div class="confirm-box">
      <div class="confirm-title">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
             stroke="#f59e0b" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
          <line x1="12" y1="9"  x2="12" y2="13"/>
          <line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
        Confirm Removal – Component will be marked as Past
      </div>
      <div class="confirm-grid">
        <span class="cg-key">Truck</span>
        <span class="cg-val">{{truckDetails?.truckNumber}}</span>

        <span class="cg-key">Component</span>
        <span class="cg-val" id="sum-component"><span class="cg-dash">{{selectedComponent?.componentType}}</span></span>

        <span class="cg-key">KM Run on Truck</span>
        <span class="cg-val" id="sum-kmrun"><span class="cg-dash">{{selectedComponent?.initialKmTravelled}}</span></span>

        <span class="cg-key">Removal Date</span>
        <span class="cg-val" id="sum-date"><span class="cg-dash">{{deAssociationDate | CustomDatePipe : 'D-M-YYYY'}}</span></span>

        <span class="cg-key">KM at Removal</span>
        <span class="cg-val" id="sum-km"><span class="cg-dash">{{deAssociationkm}}</span></span>

        <span class="cg-key">New Status</span>
        <span class="cg-val cg-past"><span class="grey-dot"></span> {{deAssociationStatus}}</span>
      </div>
    </div>
  </div>

  <!-- FOOTER -->
  <div class="modal-footer">
    <div class="footer-note">Status set to Past. This cannot be undone.</div>
    <div class="footer-actions">
      <button class="btn btn-cancel" (click)="close()">Cancel</button>
      <button class="btn btn-confirm" id="confirmBtn" (click)="removeBuildComponent()" [disabled]="!deAssociationDate || !deAssociationkm || !deAssociationStatus || !selectedComponent">Confirm Removal</button>
    </div>
  </div>
</div>